import React from 'react';
import { theme, fontStack, bodyFont } from '../theme';
import { CrossIcon } from './shared';
import churchConfig from '../churchConfig';
import { useChurchData, useChurchInfo } from '../data/ChurchDataProvider';

const BASE_PAGES = ["Home", "About", "Announcements", "Resources"];

export default function Footer({ setCurrentPage }) {
  const { data } = useChurchData();
  const info = useChurchInfo();
  const addr = info.address;

  const PAGES = data.givingEnabled
    ? [...BASE_PAGES, "Giving", "Join Us"]
    : [...BASE_PAGES, "Join Us"];
  return (
    <footer style={{ padding: "60px 24px 30px", borderTop: `1px solid ${theme.border}`, background: theme.accent, position: "relative" }}>
      <div style={{ maxWidth: 1000, margin: "0 auto", display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: 40, marginBottom: 40 }}>
        <div>
          <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 16 }}>
            <CrossIcon size={22} />
            <div>
              <div style={{ fontFamily: fontStack, fontSize: 16, fontWeight: 600, color: theme.cream }}>NEW PROSPECT</div>
              <div style={{ fontFamily: bodyFont, fontSize: 9, color: theme.gold, letterSpacing: "0.25em", textTransform: "uppercase" }}>Baptist Church</div>
            </div>
          </div>
          <p style={{ fontFamily: bodyFont, fontSize: 13, color: theme.textMuted, lineHeight: 1.7 }}>
            {info.tagline}
          </p>
        </div>

        <div>
          <h4 style={{ fontFamily: bodyFont, fontSize: 11, fontWeight: 600, color: theme.gold, letterSpacing: "0.2em", textTransform: "uppercase", marginBottom: 16 }}>Quick Links</h4>
          {PAGES.map(p => (
            <button key={p} onClick={() => { setCurrentPage(p); window.scrollTo({ top: 0, behavior: "smooth" }); }}
              style={{ display: "block", background: "none", border: "none", fontFamily: bodyFont, fontSize: 14, color: theme.textMuted, cursor: "pointer", padding: "4px 0", transition: "color 0.3s" }}
              onMouseEnter={e => e.target.style.color = theme.gold}
              onMouseLeave={e => e.target.style.color = theme.textMuted}
            >{p}</button>
          ))}
        </div>

        <div>
          <h4 style={{ fontFamily: bodyFont, fontSize: 11, fontWeight: 600, color: theme.gold, letterSpacing: "0.2em", textTransform: "uppercase", marginBottom: 16 }}>Contact</h4>
          <p style={{ fontFamily: bodyFont, fontSize: 14, color: theme.textMuted, lineHeight: 1.8 }}>
            {addr.street}<br />
            {addr.city}, {addr.state} {addr.zip}<br />
            {info.phone}<br />
            {info.website}
          </p>
        </div>

        <div>
          <h4 style={{ fontFamily: bodyFont, fontSize: 11, fontWeight: 600, color: theme.gold, letterSpacing: "0.2em", textTransform: "uppercase", marginBottom: 16 }}>Worship With Us</h4>
          <div style={{ fontFamily: bodyFont, fontSize: 14, color: theme.textMuted, lineHeight: 1.8 }}>
            {data.heroServices.map((s, i) => (
              <div key={s.id || i}>{s.name}: {s.time}</div>
            ))}
          </div>
          <p style={{ fontFamily: bodyFont, fontSize: 12, color: theme.gold, marginTop: 12 }}>
            {info.eGiving}
          </p>
        </div>
      </div>

      <div style={{ borderTop: `1px solid ${theme.border}`, paddingTop: 20, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <p style={{ fontFamily: bodyFont, fontSize: 12, color: theme.textMuted }}>
          © {new Date().getFullYear()} New Prospect Baptist Church. All rights reserved. | {addr.city}, {addr.state}
        </p>
        <button
          onClick={() => { setCurrentPage("Admin"); window.scrollTo({ top: 0, behavior: "smooth" }); }}
          style={{
            background: "none", border: "none", cursor: "pointer",
            fontFamily: bodyFont, fontSize: 11, color: theme.border,
            transition: "color 0.3s", padding: "4px 8px",
          }}
          onMouseEnter={e => e.target.style.color = theme.textMuted}
          onMouseLeave={e => e.target.style.color = theme.border}
          title="Staff Login"
        >
          Staff Login
        </button>
      </div>
    </footer>
  );
}
